import { Moment } from "moment";

export enum CampaignType {
    CASE = 'CASE',
    COUNTRY = 'COUNTRY',
    OPERATORS = 'OPERATORS',
    CASE_OPERATORS = 'CASE_OPERATORS',
    COUNTRY_OPERATORS = 'COUNTRY_OPERATORS',
    INDIVIDUALS = 'INDIVIDUALS'
}

export const CampaignScheduleValues = ['year', 'semester', 'quarter', 'month', 'week', 'once'] as const;
export type CampaignSchedule = typeof CampaignScheduleValues[number];

export type CampaignTarget = {
    id: string;
    code: string;
} | {
    ref: string;
    reference: string;
    trademark: {
        ref: string,
        name: string;
        identifierNumber: string;
        countryOfDesignation: string;
    }
} | {
    ref: string;
    firstName: string;
    lastName: string;
    avatar: string;
    email: string;
}


export interface Campaign {
    _id: string;
    name: string;
    organizationId: string;
    type: CampaignType;
    schedule: CampaignSchedule;
    targets: CampaignTarget[];
    enabled: boolean;
    owner: {
        ref: string;
        firstName: string;
        lastName: string;
        avatar: string;
    },
    createdAt: Moment;
    entity: {
        type: "none" | "trademark" | "trademarkFamily",
        ref?: string;
        label?: string;
    },
    lastExecution?: {
        executedAt: Moment;
        recipients: [
            {
                ref: string;
                firstName: string;
                lastName: string;
                email: string;
                avatar: string;
            }
        ]
    }
}